import React from 'react';
import { Alert, Button, Card, Radio, Checkbox, Col, Form, Icon, Input, message, Modal, Row, Select, DatePicker, TimePicker, InputNumber } from 'antd';
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import Iconfont from "../../components/Iconfont/Iconfont";
import { findEventCiFormPreset, updateEventCiForm } from "../../services/evt";
import { isValidity } from "../../services/global";
import styled from "styled-components";
import moment from 'moment';
import lodash from "lodash"
import PurchaseServiceTips from "../PurchaseServiceTips";
import YiDong from "../../style/imgs/yidong.png"


const CiFormRow = styled(Row)`
    .ant-form-item{
      margin-bottom: 0;
    }
    .ant-form-explain{
      display: none;
    }
    .ant-form-inline{
      .ant-form-item{
        display:block;
        margin-bottom: 8px;
        }
      
    }

`

const PresetView = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content:flex-start;
    .cifield-unique{
      width:70px;
    }
    .cifield-require{
      width:70px;
    }
   
`
const Preset = styled.div`
    // background:  url(${YiDong}) no-repeat 0 6px;
    background-size: 20px auto;
    // padding-left:30px;
    margin-bottom: 18px;
    display: flex;
    flex-wrap: nowrap;
    justify-content:flex-start;
    &:hover {
      cursor: move;
    }
    .cifield-move{
      width:30px;
      display: none;
      flex-shrink:0;
    }
    .cifield-require{
      width:70px;
      margin-top: 5px;
      flex-shrink:0;
    }
    .cifield-hide{
      display: none;
    }
    .cifield-tools{
       width:112px;
       flex-shrink:0;
       margin-top: 5px;
       padding: 0 15px;
       font-size: 14px;
       a{
        margin-right:8px;
       }
       a:last-of-type{
        margin-right:0;
       }

    }
    .cifield-mc{
      width: 100%;
      >.ant-input-group-wrapper{
         margin-bottom: 5px;
      }
      .ffoptions{
          margin-top: 3px;
      }
      .ffoption{
          display: flex;
          flex-wrap: nowrap;
          align-items: baseline;
          margin-bottom: 3px;
          >.minput{
            // width:80%;
            a{
                margin-right:8px;
               }
               a:last-of-type{
                margin-right:0;
               }
          }
      }
      .ffoption-tools{
        >a{
          padding-left: 8px;
          .anticon{
            font-size: 14px;
            margin-right: 10px;
          }
          font-size: 13px;
        }
      }
     
    }
   
`


const PresetWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
     justify-content:space-around;
    &>button, &>.placeholderdiv{
      width: 75px;
      padding: 0 3px;
      margin:3px 3px;
    }
`

const CustomPresetWrap = styled.div`
   &>button{
      width:100%;
      padding: 0 3px;
      margin:3px 3px;
   }
`

class EvtViewRegistrationForm extends React.Component {

    componentDidUpdate() {
        if (this.state.needReloadUniqueSelect) {
            this.setState({
                needReloadUniqueSelect: false
            }, () => {
                const { form } = this.props;
                var fieldsValue = form.getFieldsValue();
                var fieldUniqueIndex = lodash.get(fieldsValue, `fieldUniqueIndex`);
                var tempFields = lodash.get(fieldsValue, `_fields`);
                var realFields = lodash.get(fieldsValue, `fields`);
                var designatedUniqueFieldIndex = null;
                const fields = tempFields ? tempFields : [];
                const uniqueFieldIndexs = fields.map((f, findex) => {
                    if (f.type == "TEXT" && (!f.constraint || lodash.startsWith(f.constraint, "^") || lodash.startsWith(f.constraint, "mobile") || lodash.startsWith(f.constraint, "email") || lodash.startsWith(f.constraint, "text"))) {
                        if (designatedUniqueFieldIndex == null && f.unique) {
                            designatedUniqueFieldIndex = findex;
                        }
                        return findex;
                    }
                    return null;
                }).filter(opt => opt != null);

                if (designatedUniqueFieldIndex != null) {
                    const uindex = designatedUniqueFieldIndex;
                    lodash.set(fieldsValue, `fieldUniqueIndex`, `${uindex}`);
                    tempFields[uindex].required = true;
                    realFields[uindex].required = true;
                    lodash.set(fieldsValue, `_fields`, tempFields);
                    lodash.set(fieldsValue, `fields`, realFields);
                    form.setFieldsValue(fieldsValue);

                } else if (uniqueFieldIndexs.length == 0) {
                    lodash.set(fieldsValue, `fieldUniqueIndex`, null);
                    form.setFieldsValue(fieldsValue);
                } else if (fieldUniqueIndex == null || !lodash.includes(uniqueFieldIndexs, parseInt(fieldUniqueIndex))) {

                    const uindex = lodash.first(uniqueFieldIndexs);
                    lodash.set(fieldsValue, `fieldUniqueIndex`, `${uindex}`);

                    tempFields[uindex].required = true;
                    realFields[uindex].required = true;
                    lodash.set(fieldsValue, `_fields`, tempFields);
                    lodash.set(fieldsValue, `fields`, realFields);
                    form.setFieldsValue(fieldsValue);
                }
            });
        }
    }

    constructor(props) {
        super(props);
        this.colSelectionItemPlaceholder = document.createElement("div");
        this.colSelectionItemPlaceholder.className = "field-item-placeholder";
        this.state = {
            formLoading: false,
            needReloadUniqueSelect: true,
            preset: [],
        }
    }


    componentDidMount() {
        findEventCiFormPreset().then(res => {
            if (res.code == 200) {
                this.setState({
                    preset: res.data
                })
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })

        isValidity('WXCHECKINZEROINPUT', (vaild) => {
            this.setState({
                validity: vaild
            })
        })
    }

    resetFormFields = () => {
        this.props.form.resetFields();
        this.setState({
            needReloadUniqueSelect: true,
        })
    }


    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                const addKey = arr => arr.map(item => (Object.assign(
                    {
                        ...item,
                        label: item.value,
                    },
                    item.children ? { children: addKey(item.children) } : {}
                )))
                //去除_开头的属性(为了动态字段添加的)
                var _values = { ...values };
                console.log('success', _values);
                _values["fields"][_values["fieldUniqueIndex"]].unique = true;
                delete _values["fieldUniqueIndex"];
                Object.keys(_values).forEach((key) => {
                    if (key != "fields" && key.startsWith("_")) {
                        delete _values[key]
                    }
                })
                //展示
                if (_values.fields.filter(obj => obj.display).length > 3) {
                    message.error('「主要」最多三项，「主要」信息不影响报名，仅作为主办方列表展示，请合理设置。');
                    return false;
                }
                _values.fields.forEach((obj, index) => {
                    obj.seq = index + 1;
                    if (obj.start && obj.constraint && lodash.startsWith(obj.constraint, "date")) {
                        obj.start = moment(obj.start).format("YYYY-MM-DD");
                        obj.end = moment(obj.end).format("YYYY-MM-DD");
                    } else if (obj.start && obj.constraint && lodash.startsWith(obj.constraint, "time")) {
                        obj.start = moment(obj.start).format("HH:mm");
                        obj.end = moment(obj.end).format("HH:mm");
                    } else if (obj.constraint && lodash.startsWith(obj.constraint, "dropdown:")) {
                        obj.dropDownJson = JSON.stringify(addKey(obj.dropDownJson))
                    } else if (obj.type == "SINGLECHOICE" || obj.type == "MULTIPLECHOICE") {
                        obj.options.forEach((option, oindex) => {
                            option.seq = oindex;
                        })
                    }

                    if (!this.state.validity) {
                        obj.enableTimeControl = false
                    }
                })
                updateEventCiForm(Object.assign({ eventId: this.props.evt.header.id }, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
                console.log('success', _values);
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    handleOk = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }
    handleCancel = () => {
        this.changeFormLoading(false)
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    addField = (fieldName, value = {}) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        var _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        if (_fieldVal) {
            _fieldVal.push(value)
        } else {
            _fieldVal = [value]
        }


        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);

        form.setFieldsValue(fieldsValue);

        this.setState({
            needReloadUniqueSelect: true,
        })
    }

    removeField = (fieldName, index) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        let fieldVal = lodash.get(fieldsValue, fieldName);
        let _fieldVal = lodash.get(fieldsValue, `_${fieldName}`);
        fieldVal.splice(index, 1);
        _fieldVal.splice(index, 1);

        lodash.set(fieldsValue, `_${fieldName}`, _fieldVal);
        lodash.set(fieldsValue, fieldName, fieldVal);

        form.setFieldsValue(fieldsValue);

        this.setState({
            needReloadUniqueSelect: true,
        })
    }
    updateField = (fieldName, index, value) => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        lodash.set(fieldsValue, `_${fieldName}[${index}].enableTimeControl`, value);
        // lodash.set(fieldsValue, `${fieldName}[${index}]`, value);

        form.setFieldsValue(fieldsValue);

    }
    showBindTicketsModal = (record, fieldName) => {
        this.setState({
            fieldData: record,
            bindTicketType: record.ticketingIds && record.ticketingIds.length > 0 ? true : false,
            ticketingIds: record.ticketingIds ? record.ticketingIds : [],
            selectProName: fieldName,
        }, () => this.setState({ bindTicketVisible: true }))
    }
    hideBindTicketsModal = () => {
        this.setState({ bindTicketVisible: false })
    }
    setField = () => {
        const { form } = this.props;
        var fieldsValue = form.getFieldsValue();
        let ticketingIds = this.state.bindTicketType ? this.state.ticketingIds : [];
        lodash.set(fieldsValue, `${this.state.selectProName}`, ticketingIds);
        lodash.set(fieldsValue, `_${this.state.selectProName}`, ticketingIds);
        form.setFieldsValue(fieldsValue);
        this.setState({ bindTicketVisible: false })
    }
    columnsControlItemDragOver = (e) => {
        e.preventDefault();
        this.dragged.style.display = "none";
        console.log(e.target.className.indexOf('field-item'))
        //确保拖拽目标
        if (e.target.className == "field-item-placeholder" || e.target.className.indexOf('field-item') == -1) {
            console.log('1')
            return;
        } else {
            console.log('2')
        }
        this.over = e.target;
        e.target.parentNode.insertBefore(this.colSelectionItemPlaceholder, e.target);
    }
    columnsControlItemDragStart = (e) => {
        this.dragged = e.currentTarget;
        e.dataTransfer.effectAllowed = 'move';
        // Firefox requires calling dataTransfer .setData
        // for the drag to properly work
        e.dataTransfer.setData("text/html", e.currentTarget);
    }

    columnsControlItemDragEnd = (e) => {
        const { getFieldDecorator, getFieldValue, getFieldError, setFieldsValue, getFieldsValue } = this.props.form;
        console.log(e)
        console.log(this.dragged)
        this.dragged.style.display = "flex";
        if (!this.dragged.parentNode.contains(this.colSelectionItemPlaceholder)) {
            return;
        }
        this.dragged.parentNode.removeChild(this.colSelectionItemPlaceholder);

        // Upd ate state
        var fieldsValue = getFieldsValue();
        var columns = fieldsValue._fields;
        var columns1 = fieldsValue.fields;
        var from = Number(this.dragged.dataset.index);
        var to = Number(this.over.dataset.index);
        let fieldUniqueIndex = Number(lodash.get(fieldsValue, `fieldUniqueIndex`));
        if (columns[from].type == 'MULTIPLECHOICE' || columns[from].type == 'SINGLECHOICE') {
            columns[from].options = columns1[from].options;
        }

        if (from == fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${to}`);
        } else if (from < fieldUniqueIndex && to >= fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${fieldUniqueIndex - 1}`);
        } else if (from > fieldUniqueIndex && to <= fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${fieldUniqueIndex + 1}`);
        }

        // if (from < to) to--;

        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        console.log(fieldsValue)
        setFieldsValue(fieldsValue);
        this.dragged = null;
    }
    //移动
    moveQuestionsItem = (index, type) => {
        const { setFieldsValue, getFieldsValue } = this.props.form;
        let fieldsValue = getFieldsValue();
        let columns = fieldsValue._fields;
        let columns1 = fieldsValue.fields;
        let from = index;
        let to = type == 'up' ? index - 1 : index + 1;
        let fieldUniqueIndex = Number(lodash.get(fieldsValue, `fieldUniqueIndex`));
        if (columns[index].type == 'MULTIPLECHOICE' || columns[index].type == 'SINGLECHOICE') {
            columns[index].options = columns1[index].options;
        }


        if (from == fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${to}`);
        } else if (from < fieldUniqueIndex && to >= fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${fieldUniqueIndex - 1}`);
        } else if (from > fieldUniqueIndex && to <= fieldUniqueIndex) {
            lodash.set(fieldsValue, `fieldUniqueIndex`, `${fieldUniqueIndex + 1}`);
        }
        // if (from < to) to--;
        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        setFieldsValue(fieldsValue);
    }
    //移动选项
    moveOptionItem = (fieldName, index, type) => {
        const { setFieldsValue, getFieldsValue } = this.props.form;
        let fieldsValue = getFieldsValue();
        let columns = lodash.get(fieldsValue, `_${fieldName}`);
        let columns1 = lodash.get(fieldsValue, fieldName);
        let from = index;
        let to = type == 'up' ? index - 1 : index + 1;
        // if (from < to) to--;

        columns.splice(to, 0, columns.splice(from, 1)[0]);
        columns1.splice(to, 0, columns1.splice(from, 1)[0]);
        setFieldsValue(fieldsValue);
    }

    render() {
        const evt = this.props.evt;
        const evtFields = evt.form.fields;

        const { getFieldDecorator, getFieldValue, getFieldError, setFieldsValue, getFieldsValue } = this.props.form;

        getFieldDecorator('_fields', {
            initialValue: evtFields.map(f => {
                if (f.constraint && lodash.startsWith(f.constraint, "dropdown:")) {
                    if (typeof f.dropDownJson == "string") {
                        f.dropDownJson = JSON.parse(f.dropDownJson);
                    }

                }
                return f;
            })
        });
        const _fields = getFieldValue('_fields') ? getFieldValue('_fields') : [];
        const fields = getFieldValue('fields') ? getFieldValue('fields') : [];
        console.log(_fields)
        console.log(getFieldValue('fieldUniqueIndex'))
        const formItemLayoutFileds = {
            labelCol: {
                xs: { span: 4 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 20 },
                sm: { span: 20 },
            },
        };

        return (
            <Form>
                <div>
                    {
                        evtFields.map((f, index) => {
                            return (
                                <PresetView key={`adsfa1134sdf${index}`}>
                                    <div className="cifield-unique">
                                        {f.unique ? "唯一" : ""}
                                    </div>
                                    <div className="cifield-require">
                                        {f.display ? "主要" : ""}
                                    </div>
                                    <div className="cifield-require">
                                        {f.required ? "必填" : ""}
                                    </div>
                                    <div className="cifield-mc">
                                        {f.name}
                                    </div>
                                </PresetView>
                            )
                        })
                    }
                </div>
                <Modal
                    visible={this.props.editable}
                    title="编辑报名表"
                    width="850px"
                    maskClosable={false}
                    afterClose={() => this.resetFormFields()}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>
                            放弃
                        </Button>,
                        <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                            保存
                        </Button>,
                    ]}
                >
                    <CiFormRow>
                        <Col span={24}>
                            <Card noHovering={true} bodyStyle={{ padding: "15px 22px" }}>
                                <Alert message={<div>
                                    <p>1.唯一表单项非常重要，用于「签到」时输入比对，不可重复，修改：“<a href="https://www.yuque.com/odh2xi/manual/rq93cagvwtqocxv5#b0DXQ" target="_blank">  详细帮助</a>”。</p>
                                    {/*<p>2.唯一表单项，参与人报名时此项内容「不能重复」；</p>*/}
                                    <p>2.「主要」用于主办方查看，列表展示，最多3个，不影响报名；</p>
                                    <p>3. 参与人报名后，删除表单字段，该字段信息会丢失，编辑改名不会.</p>
                                </div>} type="info" />
                                <h3>
                                    <div className="ant-form ant-form-inline">
                                        <Form.Item
                                            {...formItemLayoutFileds}
                                            label="唯一表单项"
                                        >
                                            {getFieldDecorator(`fieldUniqueIndex`, {
                                                rules: [{ required: true }],
                                            })(
                                                <Select
                                                    style={{ width: 150, }}
                                                    onFocus={(e) => this.setState({ needReloadUniqueSelect: false })}
                                                    onChange={(val) => {
                                                        var fieldsValue = getFieldsValue();
                                                        var tempFields = lodash.get(fieldsValue, `_fields`);
                                                        var fields = lodash.get(fieldsValue, `fields`);
                                                        tempFields[val].required = true;
                                                        tempFields[val].display = true;
                                                        fields[val].required = true;
                                                        fields[val].display = true;
                                                        lodash.set(fieldsValue, `_fields`, tempFields);
                                                        lodash.set(fieldsValue, `fields`, fields);
                                                        setFieldsValue(fieldsValue);
                                                    }}
                                                >
                                                    {
                                                        fields.map((f, findex) => {
                                                            if (f.type == "TEXT" && (!f.constraint || lodash.startsWith(f.constraint, "^") || lodash.startsWith(f.constraint, "mobile") || lodash.startsWith(f.constraint, "email") || lodash.startsWith(f.constraint, "text"))) {
                                                                return <Select.Option key={`ooyp63c${findex}`} value={`${findex}`}>{f.name}</Select.Option>
                                                            }
                                                            return null;
                                                        }).filter(opt => opt)
                                                    }

                                                </Select>
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            {...formItemLayoutFileds}
                                            label="标题"
                                        >
                                            {getFieldDecorator(`name`, {
                                                initialValue: evt.form.name,
                                                rules: [{ required: false }, { min: 2, max: 40, message: '长度限制为2至40个之间!' }],

                                            })(
                                                <Input placeholder="设置报名页面标题和内容，如：全国第七届创新大赛信息提交" />
                                            )}
                                        </Form.Item>
                                        <Form.Item
                                            {...formItemLayoutFileds}
                                            label="说明"
                                        >
                                            {getFieldDecorator(`summary`, {
                                                initialValue: evt.form.summary,
                                                rules: [{ required: false }, { min: 2, max: 200, message: '长度限制为2至200个之间!' }],
                                            })(
                                                <Input.TextArea autosize={{ minRows: 2, maxRows: 3 }} placeholder="报名页面显示的注意事项，如：请认真填写以下信息，主委会将严格审核且保密，如填写错误，请联系王经理13800138000" />
                                            )}
                                        </Form.Item>
                                    </div>
                                </h3>
                            </Card>
                        </Col>
                        <Col span={16}
                            // onDragOver={this.columnsControlItemDragOver}
                            className='field-container'>
                            {
                                _fields.map((f, findex) => {
                                    var desComp = null;
                                    var typeDes = "文本框";
                                    var display = true;
                                    var dateTime = false;
                                    if (f.type == "TEXT") {
                                        if (f.constraint) {
                                            if (lodash.startsWith(f.constraint, "img")) {
                                                typeDes = <span>
                                                    {/*<Icon type="picture" />*/}
                                                    图 片</span>
                                                display = false;
                                            } else if (lodash.startsWith(f.constraint, "mobile")) {
                                                typeDes = <span>
                                                    {/*<Icon type={'mobile'}/>*/}
                                                    手 机</span>
                                            } else if (lodash.startsWith(f.constraint, "email")) {
                                                typeDes = <span>
                                                    {/*<Icon type="mail" />*/}
                                                    邮 箱</span>
                                            } else if (lodash.startsWith(f.constraint, "multipletext")) {
                                                typeDes = "多行文本"
                                            } else if (lodash.startsWith(f.constraint, "date")) {
                                                typeDes = "日 期";
                                                dateTime = true;
                                                desComp = (f.enableTimeControl && <div className={"ffoptions"}>
                                                    <div className={"ffoption"}>
                                                        <div className="cifield-hide">

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].start`, {
                                                                    initialValue: f.start ? moment(f.start) : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <DatePicker placeholder="开始范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                            <Form.Item style={{ display: 'inline-block', }}>
                                                                {getFieldDecorator(`fields[${findex}].end`, {
                                                                    initialValue: f.end ? moment(f.end) : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <DatePicker placeholder="结束范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>)
                                            } else if (lodash.startsWith(f.constraint, "time")) {
                                                typeDes = "时 间";
                                                dateTime = true;
                                                desComp = (f.enableTimeControl && <div className={"ffoptions"}>
                                                    <div className={"ffoption"}>
                                                        <div className="cifield-hide">

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].start`, {
                                                                    initialValue: f.start ? moment(f.start, 'HH:mm') : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <TimePicker format={'HH:mm'} placeholder="开始范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                            <Form.Item style={{ display: 'inline-block', }}>
                                                                {getFieldDecorator(`fields[${findex}].end`, {
                                                                    initialValue: f.end ? moment(f.end, 'HH:mm') : null,
                                                                    rules: [{ required: true }],
                                                                })(
                                                                    <TimePicker format={'HH:mm'} placeholder="结束范围" style={{ width: 105 }} />
                                                                )}
                                                            </Form.Item>
                                                        </div>
                                                    </div>
                                                </div>)
                                            } else if (lodash.startsWith(f.constraint, "address")) {
                                                typeDes = "省市区详"
                                            } else if (lodash.startsWith(f.constraint, "dropdownprovince") || lodash.startsWith(f.constraint, "dropdowncity") || lodash.startsWith(f.constraint, "dropdownarea")) {
                                                if (lodash.startsWith(f.constraint, "dropdownprovince")) {
                                                    typeDes = "省"
                                                } else if (lodash.startsWith(f.constraint, "dropdowncity")) {
                                                    typeDes = "省市"
                                                } else {
                                                    typeDes = "省市区"
                                                }

                                                desComp = <span style={{ display: 'none' }}>
                                                    {getFieldDecorator(`fields[${findex}].dropDownJson`, {
                                                        initialValue: f.dropDownJson,
                                                        rules: [{ required: false }],
                                                    })(
                                                        <Input />
                                                    )}
                                                </span>
                                            } else if (lodash.endsWith(f.constraint, "^[0-9]*$")) {
                                                typeDes = "纯数字"
                                            } else if (lodash.endsWith(f.constraint, "^[a-zA-Z]*$")) {
                                                typeDes = "纯字母"
                                            } else if (lodash.includes(f.constraint, "u9fa5")) {
                                                typeDes = "纯汉字"
                                            } else if (lodash.endsWith(f.constraint, "^([a-zA-z]+://[^s]*)$")) {
                                                typeDes = "网 址"
                                            } else if (lodash.includes(f.constraint, "Xx")) {
                                                typeDes = "身份证"
                                            } else if (lodash.startsWith(f.constraint, "dropdown:")) {
                                                typeDes = "联动下拉"
                                                desComp = <div className={"ffoptions"}>{
                                                    f.dropDownJson.map((opt, oindex) => {
                                                        return (
                                                            <div key={`aaaasd23233782-${oindex}`}>
                                                                <div className="minput">
                                                                    <Form.Item style={{ marginRight: 8 }}>
                                                                        {getFieldDecorator(`fields[${findex}].dropDownJson[${oindex}].value`, {
                                                                            initialValue: opt.value,
                                                                            rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                        })(
                                                                            <Input addonBefore={<span>{oindex + 1}</span>} addonAfter={
                                                                                oindex > 1 ? <a onClick={() => this.removeField(`fields[${findex}].dropDownJson`, oindex)}><Icon type={"close-circle-o"} /></a> : null
                                                                            } />
                                                                        )}
                                                                    </Form.Item>

                                                                </div>
                                                                <div className={"ffoptions"} style={{ paddingLeft: 22 }}>
                                                                    {opt.children &&
                                                                        opt.children.map((_opt, _oindex) => {
                                                                            return (
                                                                                <div key={`aaaasd23233782-${_oindex}`}>
                                                                                    <div className={"ffoption"} >
                                                                                        <div className="minput">
                                                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                                                {getFieldDecorator(`fields[${findex}].dropDownJson[${oindex}].children[${_oindex}].value`, {
                                                                                                    initialValue: _opt.value,
                                                                                                    rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                                                })(
                                                                                                    <Input addonBefore={<span>({_oindex + 1})</span>} addonAfter={
                                                                                                        <a onClick={() => this.removeField(`fields[${findex}].dropDownJson.[${oindex}].children`, _oindex)}><Icon type={"close-circle-o"} /></a>
                                                                                                    } />
                                                                                                )}
                                                                                            </Form.Item>
                                                                                            <a onClick={() => this.addField(`fields[${findex}].dropDownJson[${oindex}].children[${_oindex}].children`, { value: '子项目' })}>三级项</a>

                                                                                        </div>
                                                                                    </div>
                                                                                    {_opt.children &&
                                                                                        _opt.children.map((__opt, __oindex) => (
                                                                                            <div className={"ffoption"} >
                                                                                                <div className="minput">
                                                                                                    <Form.Item style={{ display: 'inline-block', }}>
                                                                                                        {getFieldDecorator(`fields[${findex}].dropDownJson[${oindex}].children[${_oindex}].children[${__oindex}].value`, {
                                                                                                            initialValue: __opt.value,
                                                                                                            rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                                                        })(
                                                                                                            <Input addonAfter={
                                                                                                                <a onClick={() => this.removeField(`fields[${findex}].dropDownJson[${oindex}].children[${_oindex}].children`, __oindex)}><Icon type={"close-circle-o"} /></a>
                                                                                                            } />
                                                                                                        )}
                                                                                                    </Form.Item>

                                                                                                </div>
                                                                                            </div>
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    <div className="ffoption-tools">
                                                                        <a onClick={() => this.addField(`fields[${findex}].dropDownJson[${oindex}].children`, { value: '子项目', })}><Icon type={"plus-circle-o"} />二级项</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                    <div className="ffoption-tools">
                                                        <a onClick={() => this.addField(`fields[${findex}].dropDownJson`, { value: '子项目', children: [{ value: '子项目', }] })}><Icon type={"plus-circle-o"} />一级项</a>
                                                    </div>
                                                </div>
                                            }
                                        }


                                    } else if (f.type == "SINGLECHOICE") {
                                        typeDes = "单选题"
                                        display = false;
                                        desComp = <div className={"ffoptions"}>{
                                            f.options.map((opt, oindex) => {
                                                return (
                                                    <div className={"ffoption"} key={`aaaasd23233782-${oindex}`}>
                                                        <div className="cifield-hide">
                                                            {getFieldDecorator(`fields[${findex}].options[${oindex}].id`, {
                                                                initialValue: opt.id,
                                                                rules: [{ required: false }],
                                                            })(
                                                                <Input />
                                                            )}

                                                        </div>
                                                        <div className="minput">
                                                            <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                {getFieldDecorator(`fields[${findex}].options[${oindex}].name`, {
                                                                    initialValue: opt.name,
                                                                    rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                })(
                                                                    <Input addonBefore={<span className="ant-radio-inner"></span>} addonAfter={
                                                                        oindex > 1 ? <a onClick={() => this.removeField(`fields[${findex}].options`, oindex)}><Icon type={"close-circle-o"} /></a> : null
                                                                    } />
                                                                )}
                                                            </Form.Item>
                                                            {getFieldDecorator(`fields[${findex}].options[${oindex}].hidden`, {
                                                                initialValue: opt.hidden,
                                                                valuePropName: 'checked',
                                                                rules: [{ required: false }],
                                                            })(
                                                                <Checkbox>隐藏</Checkbox>
                                                            )}
                                                            {oindex != 0 &&
                                                                <a onClick={() => this.moveOptionItem(`fields[${findex}].options`, oindex, 'up')}><Icon type="arrow-up" /></a>}
                                                            {oindex != f.options.length - 1 &&
                                                                <a onClick={() => this.moveOptionItem(`fields[${findex}].options`, oindex, 'down')}><Icon type="arrow-down" /></a>}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                            <div className="ffoption-tools">
                                                <a onClick={() => this.addField(`fields[${findex}].options`, { name: `子项目` })}><Icon type={"plus-circle-o"} />添加选项</a>
                                            </div>
                                        </div>
                                    } else if (f.type == "MULTIPLECHOICE") {
                                        typeDes = "多选题"
                                        display = false;
                                        desComp = <div className={"ffoptions"}>
                                            <div className={"ffoption"}>
                                                <div className="minput">
                                                    <span>允许最多选中个数：</span>
                                                    <Form.Item style={{ display: 'inline-block',}}>
                                                        {getFieldDecorator(`fields[${findex}].maxSelect`, {
                                                            initialValue: f.maxSelect,
                                                            rules: [{ required: false, }],
                                                        })(
                                                            <InputNumber size='small' min={0} />
                                                        )}
                                                    </Form.Item>
                                                    <span style={{color:'#959595'}}>（0表示不限制）</span>
                                                </div>
                                            </div>
                                            {
                                                f.options.map((opt, oindex) => {
                                                    return (
                                                        <div className={"ffoption"} key={`sj480kc${oindex}a8`}>
                                                            <div className="cifield-hide">
                                                                {getFieldDecorator(`fields[${findex}].options[${oindex}].id`, {
                                                                    initialValue: opt.id,
                                                                    rules: [{ required: false }],
                                                                })(
                                                                    <Input />
                                                                )}

                                                            </div>
                                                            <div className="minput">
                                                                <Form.Item style={{ display: 'inline-block', marginRight: 8 }}>
                                                                    {getFieldDecorator(`fields[${findex}].options[${oindex}].name`, {
                                                                        initialValue: opt.name,
                                                                        rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                                    })(
                                                                        <Input addonBefore={<span className="ant-checkbox-inner"></span>} addonAfter={
                                                                            oindex > 1 ? <a onClick={() => this.removeField(`fields[${findex}].options`, oindex)}><Icon type={"close-circle-o"} /></a> : null
                                                                        } />
                                                                    )}
                                                                </Form.Item>
                                                                {getFieldDecorator(`fields[${findex}].options[${oindex}].hidden`, {
                                                                    initialValue: opt.hidden,
                                                                    valuePropName: 'checked',
                                                                    rules: [{ required: false }],
                                                                })(
                                                                    <Checkbox>隐藏</Checkbox>
                                                                )}
                                                                {oindex != 0 &&
                                                                    <a onClick={() => this.moveOptionItem(`fields[${findex}].options`, oindex, 'up')}><Icon type="arrow-up" /></a>}
                                                                {oindex != f.options.length - 1 &&
                                                                    <a onClick={() => this.moveOptionItem(`fields[${findex}].options`, oindex, 'down')}><Icon type="arrow-down" /></a>}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <div className="ffoption-tools">
                                                <a onClick={() => this.addField(`fields[${findex}].options`, { name: `子项目` })}><Icon type={"plus-circle-o"} />添加选项</a>
                                            </div>
                                        </div>

                                    }

                                    const ckdisabled = findex == getFieldValue('fieldUniqueIndex') ? true : false
                                    return (
                                        <Preset className='field-item'
                                            // draggable="true"
                                            // data-index={findex}
                                            // onDragEnd={this.columnsControlItemDragEnd}
                                            // onDragStart={this.columnsControlItemDragStart}
                                            key={`adsf345345a1134sdf${findex}`}>

                                            <div className="cifield-move">
                                                <Iconfont libname="ckicon" type="move" />
                                            </div>
                                            {display ?
                                                <div className="cifield-require">
                                                    {getFieldDecorator(`fields[${findex}].display`, {
                                                        initialValue: f.display,
                                                        valuePropName: 'checked',
                                                        rules: [{ required: false }],
                                                    })(
                                                        <Checkbox disabled={ckdisabled}>主要</Checkbox>
                                                    )}

                                                </div> : ''}
                                            <div className="cifield-require">
                                                {getFieldDecorator(`fields[${findex}].required`, {
                                                    initialValue: f.required,
                                                    valuePropName: 'checked',
                                                    rules: [{ required: false }],
                                                })(
                                                    <Checkbox disabled={ckdisabled}>必填</Checkbox>
                                                )}

                                            </div>
                                            {dateTime &&
                                                <div className="cifield-require" style={{ width: 75 }}>
                                                    {getFieldDecorator(`fields[${findex}].enableTimeControl`, {
                                                        initialValue: f.enableTimeControl,
                                                        valuePropName: 'checked',
                                                        rules: [{ required: false }],
                                                    })(
                                                        <Checkbox onChange={e => {
                                                            if (!this.state.validity) {
                                                                this.setState({
                                                                    isMember: false
                                                                }, () => this.pstView.show())
                                                            } else {
                                                                this.updateField('fields', findex, e.target.checked)
                                                            }
                                                        }} >限制</Checkbox>
                                                    )}

                                                </div>}
                                            <div className="cifield-hide">
                                                {getFieldDecorator(`fields[${findex}].id`, {
                                                    initialValue: f.id,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].type`, {
                                                    initialValue: f.type,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].constraint`, {
                                                    initialValue: f.constraint,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].hidden`, {
                                                    initialValue: f.hidden,
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {getFieldDecorator(`fields[${findex}].ticketingIds`, {
                                                    initialValue: f.ticketingIds ? f.ticketingIds : [],
                                                    rules: [{ required: false }],
                                                })(
                                                    <Input />
                                                )}
                                                {/*{getFieldDecorator(`fields[${findex}].seq`, {*/}
                                                {/*initialValue: findex+1,*/}
                                                {/*rules: [{required: false}],*/}
                                                {/*})(*/}
                                                {/*<Input/>*/}
                                                {/*)}*/}
                                            </div>
                                            <div className="cifield-mc">
                                                <Form.Item>
                                                    {getFieldDecorator(`fields[${findex}].name`, {
                                                        initialValue: f.name,
                                                        rules: [{ required: true, whitespace: true }, { whitespace: true, message: '不能输入空格!' }, { min: 1, max: 100, message: '长度限制为1至100个之间!' }],
                                                    })(
                                                        <Input addonAfter={typeDes} />
                                                    )}
                                                    {desComp}
                                                </Form.Item>
                                            </div>
                                            <div className="cifield-tools">
                                                {
                                                    !ckdisabled && evt.ticketings.length > 1 && !evt.config.batchAttend && evt.config.eventMode == 'BYREGISTER' &&
                                                    <a onClick={() => this.showBindTicketsModal(f, `fields[${findex}].ticketingIds`)}><Icon type="setting" /></a>}
                                                {findex != 0 &&
                                                    <a onClick={() => this.moveQuestionsItem(findex, 'up')}><Icon type="arrow-up" /></a>}
                                                {findex != _fields.length - 1 &&
                                                    <a onClick={() => this.moveQuestionsItem(findex, 'down')}><Icon type="arrow-down" /></a>}
                                                {ckdisabled ? '' :
                                                    <a onClick={() => this.removeField(`fields`, findex)}><Icon type={"delete"} /></a>
                                                }
                                            </div>
                                        </Preset>
                                    )
                                })
                            }
                        </Col>
                        <Col span={8}>
                            <Card noHovering={true}>
                                <h3>
                                    常用项
                                </h3>
                                <PresetWrap>
                                    {
                                        this.state.preset.map((p, index) => {
                                            return <Button key={`kljsdklfjklasdf-${index}`} onClick={() => {
                                                if (!this.state.validity && lodash.startsWith(p.constraint, "file")) {
                                                    this.setState({
                                                        isMember: false
                                                    }, () => this.pstView.show());
                                                    return;
                                                }
                                                this.addField(`fields`, p)
                                            }}>{p.name}</Button>
                                        })
                                    }
                                    {
                                        this.state.preset.length == 0 ? null : Array.from(Array(3 - (this.state.preset.length % 3)).keys()).map((a, index) => <div key={`ooyp556v363c${index}`} className="placeholderdiv">&nbsp;</div>)
                                    }
                                </PresetWrap>

                                <h3 style={{ marginTop: 20 }}>
                                    自定义项
                                </h3>

                                <CustomPresetWrap>
                                    <Button onClick={() => this.addField(`fields`, { type: "TEXT", name: `文本框`, hidden: false, required: false })}>文本框</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "TEXT", name: `文本框`, constraint: "multipletext:", hidden: false, required: false })}>多行文本</Button>
                                    <Button onClick={() => {
                                        if (!this.state.validity) {
                                            this.setState({
                                                isMember: false
                                            }, () => this.pstView.show())
                                        } else {
                                            this.addField(`fields`, {
                                                type: "TEXT", name: `联动下拉`, constraint: "dropdown:", hidden: false, required: false,
                                                dropDownJson: [
                                                    { value: '子项目', children: [{ value: '子项目' }] },
                                                    { value: '子项目', children: [{ value: '子项目' }] }
                                                ]
                                            })
                                        }
                                    }}>联动下拉</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "SINGLECHOICE", name: `单选题`, hidden: false, required: false, options: [{ name: "子项目", hidden: false }, { name: "子项目", hidden: false }] })}>单选题</Button>
                                    <Button onClick={() => this.addField(`fields`, { type: "MULTIPLECHOICE", name: `多选题`, hidden: false, required: false, options: [{ name: "子项目", hidden: false }, { name: "子项目", hidden: false }] })}>多选题</Button>
                                </CustomPresetWrap>
                            </Card>
                        </Col>
                    </CiFormRow>

                </Modal>
                {
                    this.state.bindTicketVisible &&
                    <Modal
                        visible={true}
                        title={this.state.fieldData.name}
                        width="600px"
                        maskClosable={false}
                        onCancel={this.hideBindTicketsModal}
                        footer={[
                            <Button key="back" onClick={this.hideBindTicketsModal}>
                                取消
                        </Button>,
                            <Button key="submit" type="primary" onClick={() => {
                                if (!this.state.validity) {
                                    this.setState({
                                        isMember: false
                                    }, () => this.pstView.show())
                                } else {
                                    this.setField()
                                }
                            }}>
                                确定
                        </Button>,
                        ]}
                    >
                        <div>
                            <div style={{ paddingLeft: 16 }}>
                                <span>
                                    表单添加到：
                            </span>
                                <Radio.Group
                                    value={this.state.bindTicketType}
                                    onChange={e => this.setState({ bindTicketType: e.target.value })}
                                >
                                    <Radio value={false}>所有门票</Radio>
                                    <Radio value={true}>指定门票</Radio>
                                </Radio.Group>
                            </div>
                            {
                                this.state.bindTicketType &&
                                <div style={{ paddingLeft: 88, marginTop: 20, }}>
                                    <Checkbox.Group
                                        value={this.state.ticketingIds}
                                        onChange={e => { this.setState({ ticketingIds: e }) }}
                                    >
                                        {
                                            evt.ticketings.map((obj, index) => (
                                                <Checkbox key={index} value={obj.id}>{obj.name}</Checkbox>
                                            ))
                                        }
                                    </Checkbox.Group>
                                </div>}
                            <div style={{ marginTop: 50 }}>
                                <Alert message={<div>
                                    注：勾选后，参与人选择相对应的票时，需要填写此表单信息，如：选择会员票，才必须填写会员编号；或设置观众、展商等不同通道填写不同信息。
                                </div>} type="error" />
                            </div>

                        </div>

                    </Modal>}

                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={this.state.isMember ? 'MEMBER' : 'SENIORMEMBER'}

                />
            </Form>
        )
    }
}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});

EvtViewRegistrationForm.contextTypes = {}

EvtViewRegistrationForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "ticketEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewRegistrationForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewRegistrationForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewRegistrationForm.jsx